<terra-dialog-header [closeButtonReturnValue]="(codeVerificationResponse$ | async)?.isPhoneVerified">
  <h1>Phone Verification</h1>
</terra-dialog-header>

<mat-dialog-content>
  <div class="container">
    <mat-icon svgIcon="phone_verification" class="notranslate phone-verification-icon"></mat-icon>

    <h2 class="title">
      {{ !(codeVerificationResponse$ | async)?.isPhoneVerified ? 'Verify Phone Number' : 'Thanks! Your verification is complete!' }}
    </h2>

    <!-- Before code sent -->
    <ng-container *ngIf="!(isCodeSent$ | async)">
      <p class="instructions-text">
        A verification code will be sent to <span class="phone">{{ phoneNUmber }}</span>
      </p>
      <p *ngIf="context.isUserAbleToEditPhoneNumber" class="instructions-text">
        Click Send Code, or in case the number is incorrect, close this window and correct it.
      </p>

      <p class="error-message" *ngIf="isGeneralServerError$ | async">
        {{generalServerErrorMessage}}
      </p>

      <div class="actions-before-code-sent">
        <button (click)="sendSms()" [disabled]="isSendingCode$ | async" *ngIf="!(isCodeSent$ | async)"
          mat-flat-button color="primary" class="send-code-btn page-cta" type="button">
          <terra-loader *ngIf="isSendingCode$ | async"></terra-loader>
          <span>Send Code</span>
        </button>
      </div>
    </ng-container>

    <!-- After code sent -->
    <ng-container *ngIf="(isCodeSent$ | async) && !(codeVerificationResponse$ | async)?.isPhoneVerified">
      <p class="instructions-text">
        Please enter the 6 digit number we sent to
        <span class="phone">{{ phoneNUmber }}</span>
      </p>

      <form id="pageForm" [formGroup]="pageForm" (ngSubmit)="continue()">
        <terra-six-digit-code-input #codeInput *ngIf="isCodeSent$ | async" formControlName="code" [disableControl]="isSendingCode$ | async"
        class="code-input"></terra-six-digit-code-input>
      </form>

      <!-- Error messages -->
      <ng-container *ngIf="(codeVerificationResponse$ | async)?.error as error">
        <p class="error-message submit-error" *ngIf="error === PhoneVerificationErrorType.InvalidCode">
          Invalid code. Please try again.
        </p>
        <p class="error-message submit-error" *ngIf="error === PhoneVerificationErrorType.CodeExpired">
          The code is expired. Please click Resend Code and try again.
        </p>
      </ng-container>
      <p class="error-message submit-error" *ngIf="isGeneralServerError$ | async">
        {{generalServerErrorMessage}}
      </p>

      <div class="actions-after-code-sent">
        <button (click)="resendSms()" mat-flat-button class="resend-code-btn tall-button" type="button" [disabled]="isSendingCode$ | async">
          <terra-loader *ngIf="isSendingCode$ | async"></terra-loader>
          <span>Resend Code</span>
        </button>
        <button type="button" mat-button class="cancel-button tall-button" [mat-dialog-close]="undefined">Cancel</button>
        <button form="pageForm" mat-flat-button color="primary" class="continue-btn page-cta" type="submit"
          [disabled]="(isSendingCode$ | async) || (isSubmitting$ | async) || pageForm.invalid">
          <span>Continue</span>
          <terra-loader *ngIf="isSubmitting$ | async"></terra-loader>
        </button>
      </div>
    </ng-container>

    <!-- Success! -->
    <ng-container *ngIf="(codeVerificationResponse$ | async)?.isPhoneVerified">
      <div class="actions-success">
        <button [mat-dialog-close]="(codeVerificationResponse$ | async)?.isPhoneVerified" mat-flat-button color="primary" class="success-btn page-cta" type="button">
          Continue
        </button>
      </div>
    </ng-container>
  </div>
</mat-dialog-content>

<ng-template #loader>
  <terra-loader></terra-loader>
</ng-template>
